var map = {
	"./bg.json": [
		"J6QZ",
		5
	],
	"./de-CH.json": [
		"fPRk",
		6
	],
	"./de-DE.json": [
		"46Zr",
		7
	],
	"./en-US.json": [
		"Gk0g",
		8
	],
	"./fr-CH.json": [
		"F0kE",
		9
	],
	"./fr-FR.json": [
		"RUOV",
		10
	],
	"./pl.json": [
		"6Blx",
		11
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5ey7";
module.exports = webpackAsyncContext;